export default [
  {
    path: "/history",
    name: "Histórico",
    component: () =>
      import(
        /* webpackChunkName: "performance" */ "./pages/performance/performance.component.vue"
      ),
  },
];
